// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"CheckBox_checkBox__2Reld","input":"CheckBox_input__2iNvr","check":"CheckBox_check__Ne9in"};